import clsx from 'clsx'
import {omit} from 'lodash'
import {subdomainLink, pdfPreviewLink} from '../../helpers/url'
import React from 'react'
import {Link} from 'react-router-dom'
import {Consumer} from '../../context'
import Icon from '../icon'
import {inViewer, viewerGuard} from 'helpers/url'
import AssessmentLink from  'components/AssessmentLink'
import ImportedAssessmentLessonLink from 'components/imported-assessment/lesson-link'

function LessonLink (props) {
  const {key, show, to, title, href} = props
  const linkProps = omit(props, ['key', 'show'])
  const LinkElem = to
    ? Link
    : ({children}) => (<a {...{...linkProps, ...viewerGuard(linkProps)}}>{children}</a>)
  return (
  <div key={key} className={clsx(key, 'link')}>
    {show && <LinkElem {...linkProps}>
      <Icon name={key} />
    </LinkElem>}
    {!show &&
      <span className="disabled link">
        <Icon name={key} />
      </span>
    }
  </div>)
}

export default function LessonLinks (props) {
  const {id, assigned, hash, hasEpl, hasSummary, hasKey, inContract} = props
  return (<Consumer>{ context => {
    const {link, translations, languageId, profile, isDownloaded, edgeServers} = context
    const {limited} = profile.institution
    const downloaded = isDownloaded({id, hash})

    const edgeIp = edgeServers?.available && edgeServers.ips.length > 0
      ? edgeServers.ips[0]
      : null

    const downloadHref = edgeIp
      ? subdomainLink('api-support', 'catalog', 'download', `?lesson=${id}&edgeIp=${edgeIp}`)
      : subdomainLink('api-support', 'catalog', 'download', `?lesson=${id}`)

    const filter = (({key}) => {
      if (key != 'summary' && !inContract) return false
      if (['download', 'view-local-content'].indexOf(key) < 0) return true
      if (key == 'download') return inViewer && !downloaded
      if (key == 'view-local-content') return inViewer && downloaded
    })
    const tooltipTitle = (name) => `${translations[`${name}_tooltip_title`][languageId]}: ${id}`
    const links = [
      { key: 'preview',
        title: tooltipTitle('preview'),
        show: hasEpl,
        href: edgeIp
          ? `http://${edgeIp}/${id}`
          : subdomainLink('preview', '#', languageId, 'lesson', id),
        target: "_blank"
      },
      { key: 'summary',
        title: tooltipTitle('summary'),
        show: hasSummary,
        href: pdfPreviewLink('download','summary', languageId, id),
        target: "_blank"},

      { key: 'view-local-content',
        title: tooltipTitle('preview'),
        show: hasEpl,
        href: `//downloads/${id}`,
        target: "_blank"
      },
      { key: 'download',
        title: tooltipTitle('download'),
        show: hasEpl,
        href: downloadHref,
        target: "_blank"
      },
      { key: 'schedule',
        title: tooltipTitle('schedule'),
        show: hasEpl && !limited,
        to: link({lesson: id}, `${context.match.path}/schedule/:lesson`, {preserveQuery: true}) },
      { key: 'posts',
        title: tooltipTitle('posts'),
        show: hasEpl && (assigned > 0) && !limited,
        to: link({lesson: id}, `${context.match.path}/posts/:lesson`, {preserveQuery: true}) },
      { key: 'key',
        title: tooltipTitle('key'),
        show: hasKey && !limited,
        href: pdfPreviewLink('download', 'key', languageId, id),
        target: "_blank"}
    ].filter(filter)
    return (
      <div className="links">
        {links.map(LessonLink)}
        <AssessmentLink {...{...props, context}} />
        <ImportedAssessmentLessonLink assessments={props.importedAssessments} context={context} />
      </div>
    )
  }}</Consumer>)
}
